// tickets-by-source-chart.tsx — Tickets by source channel, pie.
import { PieChart, CHART_COLORS } from '@vnetwork/ui/charts';
import { Card, CardBody, CardTitle, Skeleton } from '@vnetwork/ui/primitives';
import { EmptyState } from '@vnetwork/ui/data';
import { Alert } from '@vnetwork/ui/feedback';
import type { TicketsBySource } from '@/api/tickets-statistics';

interface Props {
  data: TicketsBySource[] | undefined;
  isLoading: boolean;
  isError: boolean;
}

export function TicketsBySourceChart({ data, isLoading, isError }: Props) {
  const rows = (data ?? [])
    .filter((d) => d.total_tickets > 0)
    .sort((a, b) => b.total_tickets - a.total_tickets)
    .map((d, i) => ({
      name: d.ticket_source.replace(/_/g, ' '),
      value: d.total_tickets,
      color: CHART_COLORS[i % CHART_COLORS.length],
    }));

  return (
    <Card flat>
      <CardBody>
        <CardTitle style={{ marginBottom: 'var(--vn-space-3)' }}>Tickets by Source</CardTitle>
        {isError ? (
          <Alert tone="danger" title="Failed to load source data" />
        ) : isLoading ? (
          <Skeleton style={{ height: 240 }} />
        ) : rows.length === 0 ? (
          <EmptyState title="No data" description="No ticket source data in this date range." />
        ) : (
          <PieChart
            data={rows}
            height={240}
            showLegend
            valueFormatter={(v) => `${v ?? 0} tickets`}
          />
        )}
      </CardBody>
    </Card>
  );
}
